import axios from "axios";
import { authHeaders } from "./apiToken";

interface StorageSas {
  account: string;
  container: string;
  sas: string;
  expiresOn: string;
}

let cached: StorageSas | null = null;
let inFlight: Promise<StorageSas> | null = null;

// One short-lived token per tab, refreshed two minutes before it expires.
// Concurrent callers with a cold cache share one request.
export async function getStorageSas(): Promise<StorageSas> {
  if (cached && new Date(cached.expiresOn).getTime() - Date.now() > 2 * 60 * 1000) return cached;
  if (!inFlight) {
    inFlight = (async () => {
      const r = await axios.get<StorageSas>(
        "https://process-api-01.azure-api.net/expressapi/core/storage/sas",
        { headers: await authHeaders() }
      );
      cached = r.data;
      return cached;
    })().finally(() => {
      inFlight = null;
    });
  }
  return inFlight;
}

// Drop the cached token when storage rejects it (e.g. the delegation key was
// revoked), so the next call fetches a fresh one instead of waiting for expiry.
export function clearStorageSasIfRejected(err: unknown) {
  if ((err as { statusCode?: number })?.statusCode === 403) cached = null;
}
